import type { CSSProperties } from 'react';
import {
  bookingBrandInfoChromeBorderMixPercent,
  bookingBrandInfoChromeStyles,
  bookingBrandInfoTintMixDefaultPercent,
  teboxDesignSystem,
} from '../styles/tebox-booking';

/**
 * TeeTimeCard “spots” pill chrome — tinted brand background + hairline border, not solid fill.
 */
export function getBookingBrandInfoPillStyles(
  accentHex: string,
  overrides?: CSSProperties,
): CSSProperties {
  const accent = accentHex.trim() || teboxDesignSystem.colors.accent.primary;
  const chrome = bookingBrandInfoChromeStyles({
    primaryColor: accent,
    buttonColor: accent,
  });

  return {
    display: 'inline-flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: teboxDesignSystem.spacing.sm,
    padding: `calc(${teboxDesignSystem.spacing.xs} * 0.8) ${teboxDesignSystem.spacing.sm}`,
    borderRadius: teboxDesignSystem.components.pill.borderRadius,
    ...chrome,
    fontWeight: 500,
    fontSize: teboxDesignSystem.typography.bodySmall.fontSize,
    lineHeight: 1.35,
    fontVariantNumeric: 'tabular-nums',
    color: teboxDesignSystem.colors.text.primary,
    cursor: 'default',
    userSelect: 'none',
    flexShrink: 0,
    maxWidth: '100%',
    boxSizing: 'border-box',
    ...overrides,
  };
}

export const bookingBrandInfoPillDataAttrs = {
  'data-tebox-brand-info-chrome': 'pill',
  'data-tebox-brand-info-bg-pct': bookingBrandInfoTintMixDefaultPercent,
  'data-tebox-brand-info-border-pct': bookingBrandInfoChromeBorderMixPercent,
} as const;
